export default {"src":"/assets/_next/static/media/swipe-help.27337572.gif","height":180,"width":120,"blurWidth":0,"blurHeight":0};